export const DASHBOARD_WIDGETS = [
  { key: "quick_actions", label: "Quick Actions (whole section)" },
  { key: "qa_collect_fees", label: "Quick Action — Collect Fees" },
  { key: "qa_add_student", label: "Quick Action — Add Student" },
  { key: "qa_add_expense", label: "Quick Action — Add Expense" },
  { key: "qa_mark_attendance", label: "Quick Action — Mark Attendance" },
  { key: "qa_marks_entry", label: "Quick Action — Marks Entry" },
  { key: "qa_homework", label: "Quick Action — Homework" },
  { key: "qa_followup", label: "Quick Action — Fee Follow-up" },
  { key: "qa_due_fees", label: "Quick Action — Due Fees" },
  { key: "qa_reports", label: "Quick Action — Reports" },
  { key: "kpi_total_fees", label: "KPI — Total Fees" },
  { key: "kpi_paid_fees", label: "KPI — Paid Fees" },
  { key: "kpi_due_fees", label: "KPI — Due Fees" },
  { key: "kpi_total_discount", label: "KPI — Total Discount" },
  { key: "kpi_today_collection", label: "KPI — Today Collection" },
  { key: "kpi_today_expenses", label: "KPI — Today Expenses" },
  { key: "kpi_month_collection", label: "KPI — Month Collection" },
  { key: "kpi_month_expenses", label: "KPI — Month Expenses" },
  { key: "kpi_homework_today", label: "KPI — Homework Assigned Today" },
  { key: "fee_chart", label: "Fee Collection Chart" },
  { key: "attendance_charts", label: "Attendance Charts (Yearly / Monthly / Daily)" },
  { key: "transport_panel", label: "Transport Panel" },
  { key: "students_panel", label: "Students Attendance Panel" },
  { key: "staff_panel", label: "Staff Attendance Panel" },
  { key: "upcoming_holidays", label: "Upcoming Holidays" },
  { key: "birthdays", label: "Birthdays" },
  { key: "fee_followup", label: "Fee Follow-up" },
  { key: "leads_panel", label: "Leads / Inquiry" },
];

// Returns widget objects ordered by the saved key order, with any
// new/unknown widgets appended in their default order.
export function orderWidgets(savedOrder) {
  const saved = Array.isArray(savedOrder) ? savedOrder : [];
  const byKey = Object.fromEntries(DASHBOARD_WIDGETS.map((w) => [w.key, w]));
  const out = [];
  const seen = new Set();
  for (const k of saved) {
    if (byKey[k] && !seen.has(k)) { out.push(byKey[k]); seen.add(k); }
  }
  for (const w of DASHBOARD_WIDGETS) {
    if (!seen.has(w.key)) { out.push(w); seen.add(w.key); }
  }
  return out;
}
